
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 8"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M13.5185 1.54142L7.51853 7.2908c-.14453.13966-.33203.209-.51856.209-.18653 0-.374-.06934-.51853-.209L.481502 1.54142C.18169 1.25542.171908.780797.459033.481984.74419.181203 1.22075.171421 1.5186.459515L6.99997 5.71099 12.4814.459515c.2969-.288094.7744-.278312 1.0595.022469.2871.298813.2774.773436-.0224 1.059436z"}})])
          )
        }
      }
    